import * as React from "react";
import { createRoot } from "react-dom/client";
import {createBrowserRouter,RouterProvider,} from "react-router-dom";
import App from "./App";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";




const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    
  },
]);


createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);